import { css } from 'lit';

/** Base styles for shadow roots: global CSS does not reach inside them. */
export const shared = css`
  :host {
    display: block;
  }
  h1,
  h2,
  h3 {
    font-family: var(--ka-font-display);
    font-weight: 600;
    line-height: 1.2;
    margin: 0 0 0.5em;
    letter-spacing: 0.02em;
  }
  h1 {
    font-size: clamp(1.8rem, 5vw, 3rem);
  }
  h2 {
    font-size: clamp(1.35rem, 3.5vw, 2rem);
  }
  p {
    margin: 0 0 1em;
  }
  a {
    color: var(--ka-gold);
  }
  a:hover {
    color: var(--ka-parchment);
  }
  :focus-visible {
    outline: 3px solid var(--ka-focus);
    outline-offset: 2px;
  }
  .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    min-height: 44px;
    padding: 0.6em 1.2em;
    border: 2px solid #000;
    border-radius: var(--ka-radius);
    background: var(--ka-stone-600);
    color: var(--ka-parchment);
    box-shadow: var(--ka-bevel);
    font: 600 1rem var(--ka-font-display);
    text-decoration: none;
    cursor: pointer;
  }
  .btn:hover {
    background: var(--ka-stone-400);
    color: var(--ka-parchment);
  }
  .btn.primary {
    background: var(--ka-red);
  }
  .btn.primary:hover {
    background: var(--ka-red-bright);
  }
  .btn.green {
    background: var(--ka-foliage-dim);
  }
  .btn[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .panel {
    background: var(--ka-stone-800);
    border: 2px solid #000;
    box-shadow: var(--ka-bevel);
    padding: 1.25rem;
    position: relative;
  }
  .muted {
    color: var(--ka-parchment-dim);
  }
  .tag {
    display: inline-block;
    font: 600 0.8rem var(--ka-font-display);
    padding: 0.15em 0.5em;
    border: 1px solid currentColor;
    border-radius: var(--ka-radius);
  }
  .fixture {
    color: #111;
    background: var(--ka-gold);
    border-color: #000;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
  .grid {
    display: grid;
    gap: var(--ka-gap);
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 16rem), 1fr));
  }
`;
